import { BOOKINGS_PATH } from 'cpmCarparks/navigation';

module.exports = {
  path: BOOKINGS_PATH,
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/CarparkBookings'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/routes/show/routes/bookings/index.js